var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAreas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.7l-.6-.4C3 17.2 3 10 3 9.6c0-5 4-9 9-9s9 4 9 9c0 .3.1 7.6-8.4 13.7l-.6.4zM5 9.6c0 .3 0 6.3 7 11.6 7-5.3 7-11.3 7-11.6 0-3.9-3.1-7-7-7s-7 3.1-7 7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9c-1.8 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4c1.8 0 3.4 1.5 3.4 3.4s-1.6 3.4-3.4 3.4zm0-4.7c-.7 0-1.4.6-1.4 1.4S11.2 11 12 11s1.4-.6 1.4-1.4-.7-1.4-1.4-1.4z",
    opacity: 0.5
  })));
}

export default SvgIconAreas;